var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./BarSaldoDebtorsReport.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2581f97b!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BarSaldoDebtorsReport.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Report/BarSaldoDebtorsReport.vue
// module id = 640
// module chunks = 0